<template>
<div 
@click="onClick"
class="flex items-center w-fit text-white bg-blue-700 rounded-xxl px-3 py-1 leading-3 hover:opacity-80 cursor-pointer"
:style="mainButtonRadius"
>
  <button class="button">
    <p>{{ title }}</p>
  </button>

  <Icon v-if="iconName" class="ml-2" :name="iconName" size="25" :color="discountBtnIconColor ? discountBtnIconColor : '#fff'"/>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from "../Icon";

export default {
  props: {
    title: {}, 
    iconName:{},
    onClick: {
      type: Function,
      default: () => null
    }
  },
  computed: {
    ...mapGetters("Theme",["mainButtonRadius", "discountBtnIconColor"])
  },
  components: {
    Icon
  }
}
</script>

<style scoped>

</style>